import { render } from "./AddInvest.vue?vue&type=template&id=3288305b&scoped=true"
import script from "./AddInvest.vue?vue&type=script&lang=js"
export * from "./AddInvest.vue?vue&type=script&lang=js"

import "./AddInvest.vue?vue&type=style&index=0&id=3288305b&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3288305b"]])

export default __exports__